<template>
  <layout>
    <template v-slot:content>
      <div id="chartdivPie"></div>
    </template>
  </layout>
</template>

<script>
  import { mapGetters } from "vuex";
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  // import am4themes_animated from "@amcharts/amcharts4/themes/animated";

  export default {
    props: {
      answers: [],
    },
    data: () => ({
      questions: [],
      pieChartV: null
    }),
    created () {
      this.$i18n.locale = this.locale;
      this.loadStatistics();
    },

    computed: {
      ...mapGetters(["isLoading"]),
      locale() {
        return this.$store.getters["locale"];
      },
      /**
       * Genera los datos de la grafica de pie tomando los rango y los datos de requerimientos
       */
      answerDataPie(){
        var pieData = [];
        this.answers.forEach(answer => {
          const found = pieData.findIndex(element => element.category == answer.question);
          if(found < 0){
            pieData.push(
                {
                    "category": answer.question,
                    "count": 1
                }
            );
          } else {
              pieData[found].count ++;
          }
        });
        window.console.log(pieData);
        return pieData;
      },
    },

    watch: {
      locale (value) {
        this.$i18n.locale = value;
        this.updateHeadersLocale();
      }
    },

    methods: {
      pieChart(){
        // Pie chart - Requeriminetos
        // Create chart instance
        var chart = am4core.create("chartdivPie", am4charts.PieChart);

        // Add data
        chart.data = this.answerDataPie;
        // chart.data = [
        //   {
        //     "category": "Respuesta 1",
        //     "count": 2
        //   },
        //   {
        //     "category": "Respuesta 2",
        //     "count": 5
        //   }
        // ];

        // Add and configure Series
        var pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "count";
        pieSeries.dataFields.category = "category";
        // pieSeries.slices.template.propertyFields.fill = "color";

        // Disable ticks and labels
        pieSeries.labels.template.disabled = true;
        pieSeries.ticks.template.disabled = true;

        chart.legend = new am4charts.Legend();

        return chart;

      },
    },
    async mounted() {
      // setTimeout(() => {
      //   this.apexLoading = true
      // })

      // Genera grafica de Pie
      this.pieChartV = this.pieChart();
    },
  }
</script>

<style scoped>
.title{
  color: var(--v-primary-base);
}
.logo{
  width: 50%;
  margin: 10px;
}
#chartdivPie {
  width: 100%;
  height: 300px;
}
</style>